import React from "react";

function MessageError({ message }) {
  return <p style={{ color: "red" }}>{message}</p>;
}

export default MessageError;
